import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import { useModal } from '../Context/Context';
import S from './Close.styles';
const Close = () => {
    const modal = useModal();
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Button, { type: "button", "aria-label": "Close", onClick: (event) => {
                event.preventDefault();
                modal.onClose();
            } }, getSvgFromSystem(SystemIcon.Close))));
};
export default Close;
